import fetchUser from "./fetchUser";

export const SET_CREATE_SESSION_FLAG = "SET_CREATE_SESSION_FLAG";
export const SET_ERROR = "SET_ERROR";
export const SET_REDIRECT_ROUTE = "SET_REDIRECT_ROUTE";
export const SET_SELECTED_CLIENT = "SET_SELECTED_CLIENT";
export const SET_USER = "SET_USER";

export const createSession = (code, state) => {
  const TEST_USER_EMAIL = "globaladmin_user@mydomain.com";
  //const TEST_USER_EMAIL = "ashutosh3194@gmail.com";

  return async (dispatch, getState) => {
    const { isCreatingSession } = getState();
    if (isCreatingSession) return;

    dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: true });
    try {
      if (process.env.REACT_APP_DEVELOPMENT_MODE === "enabled") {
        const user = await fetchUser(TEST_USER_EMAIL);
        dispatch({ type: SET_USER, user });
        window.localStorage.setItem("SESSION_LOGIN_TIME", new Date().getTime());
      }

      dispatch({ type: SET_REDIRECT_ROUTE, route: "/" });
      dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: false });
    } catch (error) {
      dispatch({ type: SET_ERROR, error });
      dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: false });
    }
  };
};

export const clearSession = () => ({ type: SET_USER, user: null });

export const preventNextRedirect = () => ({
  type: SET_REDIRECT_ROUTE,
  route: null
});

export const setSelectedClient = client => ({
  type: SET_SELECTED_CLIENT,
  client
});
